// @core/api/endpoints/affiliate/get_affiliate_stats.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetAffiliateStatsResponse,
} from '../../../types/affiliate';

const BASE_PATH = '/affiliate';

/**
 * Get affiliate statistics
 * Retrieves affiliate stats by the specified identifier.
 */
export async function GetAffiliateStats(
  affiliate_id: string,
  params?: {
    period_end?: string | number | boolean;
    period_start?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<GetAffiliateStatsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/affiliates/:affiliate_id/stats`;
  requestPath = requestPath.replace(':affiliate_id', encodeURIComponent(affiliate_id));
  const requestOptions = options;
  return client.get<GetAffiliateStatsResponse>(requestPath, { ...requestOptions, params });
}
